import React from 'react';
import PropTypes from 'prop-types';
import { helpers } from '../../../core/helpers';
import './vehicleList.component.scss';

const VehicleListComponent = props => {
  const items = props.vehicles;

  return (
    <div className="vlp-list">
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th scope="col" />
              <th scope="col">YMMT</th>
              <th scope="col">MSRP</th>
              <th scope="col">List Price</th>
              <th scope="col">Invoice Price</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan="5">No vehicles found.</td>
              </tr>
            ) : (
              items.map(item => {
                return (
                  <tr onClick={e => props.onRowSelection(item.id, e)} key={item.id} className={props.selectedVehicleId === item.id ? 'row-active' : ''}>
                    <td>
                      <img src={item.image} alt="car" />
                    </td>
                    <td>{item.name}</td>
                    <td>{helpers.getCurrencyValue(item.msrp.value, item.msrp.currency)}</td>
                    <td>{helpers.getCurrencyValue(item.listPrice.value, item.listPrice.currency)}</td>
                    <td>{helpers.getCurrencyValue(item.invoicePrice.value, item.invoicePrice.currency)}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      <footer className="vlp-list-paging">
        <nav aria-label="Page navigation example">
          <button
            type="button"
            className="btn btn-default btn-prev"
            onClick={() => {
              props.onPageChanged('prev');
            }}
            disabled={props.currentPage <= 1}
          >
            <span>Previous</span>
          </button>

          <span>
            Showing {items.length} vechicles | Page {Math.floor(props.currentPage / props.pageSize + 1)}
          </span>

          <button
            type="button"
            className="btn btn-default btn-next"
            onClick={() => {
              props.onPageChanged('next');
            }}
          >
            <span>Next</span>
          </button>
        </nav>
      </footer>
    </div>
  );
};

VehicleListComponent.propTypes = {
  currentPage: PropTypes.number.isRequired,
  onPageChanged: PropTypes.func.isRequired,
  onRowSelection: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired,
  selectedVehicleId: PropTypes.string.isRequired,
  vehicles: PropTypes.array.isRequired
};

export default VehicleListComponent;



// WEBPACK FOOTER //
// ./src/components/vehicles/list/vehicleList.component.js